import React from 'react'
import { LedgerRow } from '../../Table/LedgerTable'
import { TableCell, TableRow, Typography, useTheme } from '@mui/material'
import { BreakDownLedgerVariants } from './BreakdownLedger'

export const Breakdown: React.FC<{
  breakdownRows: LedgerRow[]
  headerLabel?: string
  variant: BreakDownLedgerVariants | `${BreakDownLedgerVariants}`
  cellStyles?: React.CSSProperties | Record<string, unknown>
  headerStyles?: React.CSSProperties
}> = ({
  breakdownRows,
  headerLabel,
  variant,
  cellStyles = {},
  headerStyles = {},
}) => {
  const theme = useTheme()

  const normalStyles = {
    label: {},
    subtotal: {
      color: theme.palette.secondary.main,
      fontSize: theme.spacing(2.6),
      paddingX: 1,
      [theme.breakpoints.down('md')]: {
        fontSize: theme.spacing(3),
      },
    },
    medium: {
      color: theme.palette.primary.dark,
    },
  }

  const intlLicensingStyles = {
    label: {},
    subtotal: {
      color: theme.palette.primary.main,
      border: '1px solid red',
      fontSize: theme.spacing(2.6),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.spacing(3),
      },
    },
    medium: {
      color: theme.palette.primary.main,
    },
  }

  const balanceStyles = {
    label: { padding: theme.spacing(0, 2) },
    subtotal: {
      color: theme.palette.secondary.main,
      fontSize: theme.spacing(4),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.spacing(4),
      },
    },
    medium: {
      padding: theme.spacing(0, 2),
      marginLeft: 0,
      borderBottom: 0,
    },
  }

  let styles:
    | typeof normalStyles
    | typeof intlLicensingStyles
    | typeof balanceStyles

  switch (variant) {
    case BreakDownLedgerVariants.Normal:
      styles = normalStyles
      break
    case BreakDownLedgerVariants.InternationalLicensing:
      styles = intlLicensingStyles
      break
    default:
      styles = balanceStyles
  }

  return (
    <>
      {!!headerLabel && (
        <TableRow>
          <TableCell
            style={{
              borderBottom: 0,
              minWidth: '150px',
              ...headerStyles,
            }}
          >
            <Typography
              variant="subtitle2"
              component="h5"
              style={{ fontWeight: 'bold' }}
            >
              {headerLabel}
            </Typography>
          </TableCell>
        </TableRow>
      )}
      {breakdownRows.map(({ cells }, index) => (
        <TableRow key={index}>
          {cells.map(
            (
              {
                content,
                align,
                color = 'medium',
                colSpan,
                cssTextProps,
                cellCssProps,
              },
              index
            ) => {
              const labelStyle = color === 'main' ? styles.label : styles.medium

              const subtotalStyle = color === 'green' ? styles.subtotal : {}
              return (
                <TableCell
                  sx={{
                    ...labelStyle,
                    paddingLeft: 0,
                    // global style
                    ...cellStyles,
                    // specific cell style
                    ...cellCssProps,
                  }}
                  key={index}
                  align={align}
                  colSpan={colSpan}
                >
                  {
                    <Typography
                      sx={{
                        ...subtotalStyle,
                        ...cssTextProps,
                      }}
                      variant="subtitle2"
                      component="h5"
                    >
                      {content}
                    </Typography>
                  }
                </TableCell>
              )
            }
          )}
        </TableRow>
      ))}
    </>
  )
}
